import classNames from 'classnames'
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { suggest } from '../../../../store/suggest/suggest.actions'
import { suggestServiceCtx } from '../../../../store/suggest/suggest.service.constants'
import { setSuggestInputValue } from '../../../../store/suggest/suggestSlice'
import s from './FavoriteInput.less'

import { useDispatch } from 'react-redux'
import { useAction } from '../../../utils/react-redux'
import useDebounce from '../../../utils/useDebounce'

const FavoriteInput = forwardRef((props, ref) => {
  const { value, onChange, className, placeholder } = props

  const dispatch = useDispatch()
  const suggestFilterType = suggestServiceCtx.filter.places
  const execSuggest = useAction(suggest)
  const [cancelSuggest, setCancelSuggest] = useState(false)
  const inputRef = useRef()
  const debouncedValue = useDebounce(value, 250)
  const hasDebouncedValueChangeOnce = useRef(false) // to ignore suggest on first render

  const onSubmit = useCallback(() => {
    dispatch(setSuggestInputValue(value))
    setCancelSuggest(true)
    return Promise.resolve().then(() => blur())
  }, [value])

  useImperativeHandle(ref, () => {
    return { onSubmit }
  })

  const doSuggest = val => {
    if (cancelSuggest) {
      setCancelSuggest(false)
      return Promise.resolve()
    }
    dispatch(setSuggestInputValue(val))
    return execSuggest({ terms: val, suggestFilterType })
  }

  useEffect(() => {
    if (hasDebouncedValueChangeOnce.current) {
      doSuggest(debouncedValue)
    }
    hasDebouncedValueChangeOnce.current = true
  }, [debouncedValue])

  const handleChange = event => {
    onChange?.({ value: event.target.value })
  }

  const handleFocus = e => {
    e.target.select()
    doSuggest(value)
  }

  const blur = () => inputRef?.current.blur()

  return (
    <div className={classNames(s.container, className)}>
      <input
        ref={inputRef}
        type="text"
        id="favoriteInput"
        value={value}
        className={s.field}
        placeholder={placeholder}
        onFocus={handleFocus}
        onChange={handleChange}
        autoComplete="off"
        autoFocus
      />
    </div>
  )
})

FavoriteInput.displayName = 'FavoriteInput'
export default FavoriteInput
